import { Button, Form, Input, Select } from "antd";
import React, { useState, useEffect } from "react";
import { instance } from "utils/axios";
import CustomerHistory from "../customer/CustomerHistory";
import moment from "moment";


function CustomerForm({ form }) {
  const [loading, setLoading] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);

  // РД өөрчлөгдөхөд 10 тэмдэгт болсон үед хайна
  const handleRegChange = (e) => {
    const val = e.target.value?.trim();
    if (val && val.length === 10) {
      getCustomerInfo(val);
    } else {
      // талбаруудыг цэвэрлэнэ
      form.setFieldValue(["customer", "id"], null);
      form.setFieldValue(["customer", "firstname"], null);
      form.setFieldValue(["customer", "lastname"], null);
      form.setFieldValue(["customer", "age"], null);
      form.setFieldValue(["customer", "gender"], null);
      form.setFieldValue(["customer", "hasAllergy"], 0);
      form.setFieldValue(["customer", "allergyDescr"], null);
      form.setFieldValue(["customer", "mobile"], null);
      form.setFieldValue(["customer", "email"], null);
      setIsNotFound(false);
    }
  };

  const getCustomerInfo = (reg) => {
    setLoading(true);
    instance({ method: "get", url: `wound/find/${reg}` })
      .then((res) => {
        if (res?.data) {
          setIsNotFound(false);
          // form-оо customer namespace-р populate хийнэ
          console.log(res.data)
            const customer = res.data.customer || {};
            const sp = res.data.surgeryPlan || null;

            form.setFieldsValue({
              customer: {
                ...customer,
                regno: customer?.regno,
              },
              
            });
              form.setFieldValue(["patient", "surgeryId"], sp?.id ?? null);
              form.setFieldValue(
                ["patient", "surgeryTypeId"],
                sp?.typeId ?? null
              );
             
              form.setFieldValue(
                ["patient", "type"],
                sp != null ? "Хэвтэн" : "Амбулатори"
              );
              form.setFieldValue(["patient", "diagnosis"], sp?.diagnose ?? "");
              form.setFieldValue(
                ["patient", "surgeryDate"],
               sp?.surgeryDate ? moment(sp.surgeryDate) : null,
              );

        } else {
          // олдсонгүй -> шинээр бүртгэнэ
          form.setFieldValue(["customer", "id"], 0);
          if (
            form.getFieldValue(["customer", "regno"]).toString().length == 10
          ) {
            let regno = form
              .getFieldValue(["customer", "regno"])
              .toString()
              .substring(2, 10);

            form.setFieldValue(["customer", "gender"], parseInt(regno[6]) % 2);
            let year = parseInt(regno.substring(0, 2));
            let birthyear = year < 30 ? 2000 + year : 1900 + year;
            let today = new Date();
            let age = today.getFullYear() - birthyear;
            form.setFieldValue(["customer", "age"], age);
          }
           form.setFieldValue(["customer", "firstname"], null);
           form.setFieldValue(["customer", "lastname"], null);
           form.setFieldValue(["patient", "surgeryId"],  null);
           form.setFieldValue(["patient", "surgeryTypeId"],  null);
           form.setFieldValue(["patient", "type"], "Амбулатори");
           form.setFieldValue(["patient", "diagnosis"],"");
           form.setFieldValue(["patient", "surgeryDate"], moment());
          setIsNotFound(true);
        }
      })
      .catch(() => {
        form.setFieldValue(["customer", "id"], 0);
        setIsNotFound(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Form.Item className="col-span-12 mb-0">
        <div className="grid grid-cols-12 gap-x-4 gap-y-4">
          {/* Регистр хайх */}
          <Form.Item
            className="mb-0 col-span-12 md:col-span-6"
            label="Үйлчлүүлэгч"
          >
            <div className="flex">
              <Form.Item name={["customer", "regno"]} className="mb-0 flex-1">
                <Input
                  placeholder="Регистрийн дугаар оруулах"
                  onChange={handleRegChange}
                />
              </Form.Item>
              <Form.Item className="mb-0 ml-1">
                <Button
                  loading={loading}
                  onClick={() => {
                    const regno = form.getFieldValue(["customer", "regno"]);
                    if (regno) getCustomerInfo(regno);
                  }}
                >
                  Шалгах
                </Button>
              </Form.Item>
            </div>
          </Form.Item>

          {/* hidden id */}
          <Form.Item name={["customer", "id"]} noStyle />

          {/* Овог/Нэр */}
          <Form.Item
            name={["customer", "lastname"]}
            label="Овог"
            className="col-span-12 md:col-span-6 mb-0"
          >
            <Input disabled={!isNotFound} />
          </Form.Item>
          <Form.Item
            name={["customer", "firstname"]}
            label="Нэр"
            rules={[{ required: true, message: "Нэр оруулна уу!" }]}
            className="col-span-12 md:col-span-6 mb-0"
          >
            <Input disabled={!isNotFound} />
          </Form.Item>

          {/* Хүйс / Нас */}
          <Form.Item
            name={["customer", "gender"]}
            label="Хүйс"
            rules={[{ required: true, message: "Хүйс сонгоно уу!" }]}
            className="col-span-3 md:col-span-6 mb-0"
          >
            <Select
              options={[
                { label: "Эр", value: 1 },
                { label: "Эм", value: 0 },
              ]}
            />
          </Form.Item>
          <Form.Item
            name={["customer", "age"]}
            label="Нас"
            rules={[{ required: true, message: "Нас оруулна уу!" }]}
            className="col-span-3 md:col-span-6 mb-0"
          >
            <Input type="number" />
          </Form.Item>

          {/* Харшил */}
          <Form.Item
            name={["customer", "hasAllergy"]}
            label="Харшилтай эсэх"
            className="col-span-6 md:col-span-6 mb-0"
          >
            <Select
              defaultValue={0}
              options={[
                { label: "Тийм", value: 1 },
                { label: "Үгүй", value: 0 },
              ]}
            />
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={(prev, cur) =>
              prev.customer?.hasAllergy !== cur.customer?.hasAllergy
            }
          >
            {({ getFieldValue }) =>
              getFieldValue(["customer", "hasAllergy"]) === 1 ? (
                <Form.Item
                  label="Харшлын тайлбар"
                  name={["customer", "allergyDescr"]}
                  rules={[
                    { required: true, message: "Харшлын тайлбар оруулна уу!" },
                  ]}
                  className="col-span-12 md:col-span-6 mb-0"
                >
                  <Input.TextArea className="w-full" />
                </Form.Item>
              ) : null
            }
          </Form.Item>

          {/* Утас/Имэйл */}
          <Form.Item
            name={["customer", "mobile"]}
            label="Утас"
            className="col-span-12 md:col-span-6 mb-0"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["customer", "email"]}
            label="Имэйл"
            className="col-span-12 md:col-span-6 mb-0"
          >
            <Input />
          </Form.Item>

          {/* Түүх */}
          <Form.Item className="mb-0 ml-1" label="Түүх">
            <Button onClick={() => setOpenHistory(true)}>Харах</Button>
          </Form.Item>
          <CustomerHistory
            open={openHistory}
            onClose={() => setOpenHistory(false)}
            customerId={form.getFieldValue(["customer", "id"])}
          />
        </div>
      </Form.Item>
    </>
  );
}

export default CustomerForm;
